import { create } from 'zustand';

import type { DiffValueFrameworkChanges } from '../../data-contract/chat';

export type FrameworkProposalPreview = {
    readonly blockId: string;
    readonly changes: readonly DiffValueFrameworkChanges[];
    readonly frameworkId: string;
};

type FrameworkPreviewState = {
    readonly openBoards: Readonly<Record<string, number>>;
    readonly preview: FrameworkProposalPreview | null;
    readonly hidePreview: (blockId: string) => void;
    readonly registerBoard: (frameworkId: string) => () => void;
    readonly showPreview: (preview: FrameworkProposalPreview) => void;
};

export const useFrameworkPreviewStore = create<FrameworkPreviewState>((set) => ({
    hidePreview: (blockId) => set((state) => (state.preview?.blockId === blockId ? { preview: null } : state)),
    openBoards: {},
    preview: null,
    registerBoard: (frameworkId) => {
        set((state) => ({
            openBoards: { ...state.openBoards, [frameworkId]: (state.openBoards[frameworkId] ?? 0) + 1 },
        }));

        return () =>
            set((state) => {
                const remaining = (state.openBoards[frameworkId] ?? 1) - 1;
                const { [frameworkId]: _closed, ...openBoards } = state.openBoards;

                return {
                    openBoards: remaining > 0 ? { ...openBoards, [frameworkId]: remaining } : openBoards,
                    preview: remaining > 0 || state.preview?.frameworkId !== frameworkId ? state.preview : null,
                };
            });
    },
    showPreview: (preview) => set({ preview }),
}));
